export default "[![Dead Cool](/images/content/DeadCool_Revealed.jpg)](/images/content/DeadCool_Revealed.jpg)";